import { Component, Fragment } from 'react'
import StickyContainer from '../../../Common/Sticky/Container'
import _ from 'lodash'
import ProposalCompletion from '../ProposalCompletion/ProposalCompletion'
import { PAGE_FLOW } from '../../../../constants/proposalTypes'
import PageError from '../../../Common/PageError'
import errorHelper from '../../../../../lib/errorHelper'

const DEFAULT_ERROR_MESSAGE = '表單發生錯誤，請稍後再試'

class PageFlow extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentFlow: PAGE_FLOW.INITIAL,
      error: {
        message: DEFAULT_ERROR_MESSAGE
      }
    }
  }

  moveTo = (flowName, nextState) => {
    if (!_.isEmpty(nextState)) {
      this.setState(() => ({ ...nextState }))
    }
    this.setState(() => ({ currentFlow: flowName }))
  }

  isCurrent = (flowName) => {
    return this.state.currentFlow === flowName
  }

  render () {
    const { currentFlow } = this.state
    const {
      FixedTopComponent,
      HeadComponent,
      FormComponent,
      FootComponent,
      // 提案送出成功頁預設為 ProposalCompletion
      CompletionComponent = ProposalCompletion,
      ...restProps
    } = this.props

    /**
     * FormBaseWithStatus 提供的屬性的方法先包進 pageFlow 再傳下去，
     * 是想讓它像 redux-form 的 input, meta 那樣，
     *
     * 這樣下面的 Component（例如：HeadComponent ） 在用 props 的時候就可以知道是 PageFlow 提供的 props，
     * 還是再更上層傳進來的
     */
    const passingDownProps = Object.assign(
      restProps,
      {
        pageFlow: {
          currentFlow,
          moveTo: this.moveTo,
          isCurrent: this.isCurrent
        }
      })

    const WrapperContainer = FixedTopComponent
      ? StickyContainer
      : Fragment

    switch (currentFlow) {
      case PAGE_FLOW.INITIAL: {
        return (
          <div
            style={{
              width: '100%',
              height: 400
            }}
          />
        )
      }
      case PAGE_FLOW.ERROR: {
        const stateError = _.get(this, 'state.error')
        const error = { code: stateError.code || '', message: stateError.message }
        const apiErrorMappedMessage = errorHelper.parseErrorMessage(error)
        const errorMessage = stateError.message || apiErrorMappedMessage || DEFAULT_ERROR_MESSAGE
        return (
          <PageError
            errorMessage={errorMessage}
          />
        )
      }
      case PAGE_FLOW.SUCCESS: {
        return (
          <CompletionComponent
            key='completion'
            {...passingDownProps}
          />
        )
      }
      default: {
        return (
          <WrapperContainer key='standard'>
            {FixedTopComponent && (
              <FixedTopComponent
                key='top'
                {...passingDownProps}
              />
            )}
            {HeadComponent && (
              <HeadComponent
                key='head'
                {...passingDownProps}
              />
            )}
            {FormComponent && (
              <FormComponent
                key='form'
                {...passingDownProps}

              />
            )}
            {FootComponent && (
              <FootComponent
                key='foot'
                {...passingDownProps}
              />
            )}
          </WrapperContainer>
        )
      }
    }
  }
}

export default PageFlow
